import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
//components
import { ErrorComponent } from "components";
import Menu from "features/menu/containers/Menu";
import WithLoading from "components/Hoc/WithLoading";
import DeliveringTo from "../components/DeliveringTo";
import PickupChangeStoreTo from "../components/PickupChangeStoreTo";
import StoreCategoryWithMenu from "components/menu/StoreCategoryWithMenu";
//actions
import { CartAction } from "store/actions";
//hooks
import {
  useLang,
  useCustomHistory,
  useMenuSearch,
  useUpdateDeliveryFee,
} from "hooks";
//utils
import { calculateCartGrossAmount } from "utils/Utils";
//constants
import C from "Constants";
// import * as ROUTE_CONSTANTS from "routes/constants";
import useOpenStoreITem from "./useOpenStoreITem";
import { PreOrderingDisplayTimingWidget } from "components/Pre-ordering/index";
import useGetRecommendedItems from "service-hooks/useGetRecommendedItems";
import RecommendedITemList from "../../../components/recommended-item/RecommendedITemList";
import { HomePageHeader } from "features";
import CategoriesList from "components/menu/CategoriesList";
import DiscountsAndLoyalty from "components/discounts-loyalty";
import ServiceTypeToggler from "components/ServiceTypeToggler/SeviceTypeToggler";
import ItemModalContainer from "features/item/containers/ItemModalContainer";

const StoreContainer = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const router = useCustomHistory();
  const { currentLang } = useLang();
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearch] = useState("");
  const [openItemDetails, setOpenItemDetails] = useState({
    open: false,
    params: null,
    type: null,
  });
  const { cart } = useSelector((state) => state?.cart);
  const openStoreItem = useOpenStoreITem();
  useUpdateDeliveryFee();
  const { itemList } = useGetRecommendedItems();

  const { storeError } = useSelector((state) => state?.errorSlice);
  const { discountInfo } = useSelector((state) => state?.Discounts);
  const { DomainType, orderType } = useSelector((state) => state.AppReducer);
  const { selectedStore, outletBasedSelectedStoreArea, storeMenu } =
    useSelector((state) => state?.store);
 
  const { orderTiming } = useSelector((state) => state?.orderTimingReducer);
  const { filteredMenu } = useMenuSearch(searchTerm, storeMenu);

  useEffect(() => {
    if (
      ((orderType?.serviceType === C.SERVICE_TYPE.DELIVERY &&
        !outletBasedSelectedStoreArea) ||
        !selectedStore) &&
      !storeError?.error
    ) {
      router(`/`, `/${params?.domainName}`, DomainType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outletBasedSelectedStoreArea, selectedStore]);

  //update cart price
  const updateCart = () => {
    const { itemsGrossAmount, itemsNetPrice, orderGrossAmount } =
      calculateCartGrossAmount(cart, discountInfo);
    dispatch(
      CartAction.updateCartPrice({
        originalPrice: itemsNetPrice,
        amountAfterDiscount: itemsGrossAmount,
        itemsGrossAmount,
        orderGrossAmount,
      })
    );
  };

  useEffect(() => {
    updateCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart, discountInfo, outletBasedSelectedStoreArea, orderType]);

  const openITemDetailPage = (item, category, type) => {
    openStoreItem(item, category, setOpen, params, type, setOpenItemDetails);
  };
  
  return (
    <>
      <WithLoading>
        <div className="store-page store-page-popup">
          <HomePageHeader
            searchTerm={searchTerm}
            handleSearch={setSearch}
            selectedArea={outletBasedSelectedStoreArea}
            showManualAddress={true}
            showStoreInfo={true}
            isStorePage={true}
          />
          <ServiceTypeToggler containerClassName="mx-4 mt-3" />
          {orderType?.serviceType === C.SERVICE_TYPE.DELIVERY && (
            <DeliveringTo
              selectedArea={outletBasedSelectedStoreArea}
              lang={currentLang}
              selectedStore={selectedStore}
            />
          )}
          {orderType?.serviceType === C.SERVICE_TYPE.PICKUP && (
            <PickupChangeStoreTo
              selectedStore={selectedStore}
              lang={currentLang}
            />
          )}
          {storeError && <ErrorComponent error={storeError?.error} />}
          <PreOrderingDisplayTimingWidget
            orderTiming={orderTiming}
            route="store"
          />

          <DiscountsAndLoyalty />
          {searchTerm?.length <= 0 && (
            <div
              className="sticky top-0 bg-white px-4 shadow-md"
              style={{ zIndex: 5 }}
            >
              <CategoriesList
                categoriesList={filteredMenu}
                showHeading={true}
                showIcon={false}
                scrollOffset={200}
                showSeeAll={false}
              />
            </div>
          )}
          <RecommendedITemList
            itemidList={itemList}
            setOpen={setOpen}
            openStoreItem={openStoreItem}
          />
          <Menu
            menu={filteredMenu}
            menuType="store"
            {...{ searchTerm, setSearch }}
          >
            <StoreCategoryWithMenu
              menu={filteredMenu}
              menuType="store"
              onItemClick={openITemDetailPage}
              {...{ open, setOpen }}
              page="store"
              showCartIcon={true}
            />
          </Menu>
        </div>
       
      </WithLoading>

      {openItemDetails?.open && openItemDetails?.type === "modal" && (
        <ItemModalContainer
          {...openItemDetails}
          handleClose={() =>
            setOpenItemDetails({ open: false, params: null, type: null })
          }
          triggerCloseModal={true}
        />
      )}
    </>
  );
};

export default StoreContainer;
